import { render, staticRenderFns } from "./page27.vue?vue&type=template&id=05701fed&scoped=true&"
import script from "./page27.vue?vue&type=script&lang=js&"
export * from "./page27.vue?vue&type=script&lang=js&"
import style0 from "./page27.vue?vue&type=style&index=0&id=05701fed&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05701fed",
  null
  
)

export default component.exports